
import {Component, Vue} from "vue-property-decorator";
import {UYAP_ENGEL_METINLERI, engelSeridiSatirlari} from "@/utils/uyapEngel";

/**
 * UYAP insan doğrulaması engeli: kalıcı, KAPATILAMAYAN şerit (DEV-3572, SOZLESME §8.1 #18-21).
 *
 * `ImzaKimlikSeridi` gibi her rotada çizilir (İcraPro/OfisPro ekranları da UYAP'a istek atıyor); rota süzgeci YOK.
 * "Panel" satırı bu sekmenin kendi kilidi, "Bot" satırı botun engeli (panel biliyorsa). UYAP'ın metni şeritte
 * gösterilmez (yalnız uyarı penceresinde, düz metin olarak).
 *
 * "Yeniden denemeye izin ver" ONAYSIZ tek eylemdir (düğmenin etiketi eylemin kendisidir; onay yalnız Başlat'ta,
 * SOZLESME §13.7) ve yalnız PANEL kilidi varken görünür: botun kilidini panel kaldıramaz, bot için yol onaylı
 * Başlat'tır (K5). Yalnız Bot satırı varsa şeritte yalnız "UYAP'ı aç" kalır.
 */
@Component
export default class UyapEngelSeridi extends Vue {
  izinVeriliyor = false;
  metinler = UYAP_ENGEL_METINLERI;

  get panel(): any {
    return this.$store.getters.uyapEngeliPanel || null;
  }

  get imzaci(): any {
    return this.$store.getters.uyapEngeliImzaci || null;
  }

  get panelKilidiVar(): boolean {
    return this.panel !== null;
  }

  get aktif(): boolean {
    return this.panel !== null || this.imzaci !== null;
  }

  get satirlar() {
    return engelSeridiSatirlari({panel: this.panel, imzaci: this.imzaci});
  }

  uyapiAc() {
    this.$socket.client.emit("openUyapWindow");
  }

  async izinVer() {
    if (this.izinVeriliyor) return;
    this.izinVeriliyor = true;
    try {
      await this.$store.dispatch("uyapEngeliniKaldir");
    } finally {
      this.izinVeriliyor = false;
    }
  }
}
